export default class RegistrationRowVersionPM {
    rowVersion: string;

    constructor(rowVersion: string) {
        this.rowVersion = rowVersion;
    }
}